<div class="p-3 collaboration-media-post-create">
  <div class="border-1 surface-border border-round mb-3">
    <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
      {{ 'common.media' | translate }}
    </span>
    <div class="p-2 pb-0">
      <app-media-uploader
        #mediaUploaderComponent
        [currentUserVM]="data?.currentUser"
        [allowFromGallery]="false"
        [mediaObjectAMs]="isEditMode ? (data?.post?.media || []) : []">
      </app-media-uploader>
    </div>

    <small class="block pb-3 pl-3 text-color-secondary" *ngIf="mediaUploaderComponent?.newFiles?.length">
      {{ 'features.user.collaboration.create.files_selected' | translate:{count: mediaUploaderComponent.newFiles.length} }}
    </small>
  </div>

  <div class="border-1 surface-border border-round">
    <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
      {{ 'features.user.collaboration.create.service_summary' | translate }}
    </span>
    <div class="p-3">
      <div class="p-fluid p-float-label collaboration-media-post-create__content">
        <textarea pInputTextarea rows="5" [autoResize]="true" [(ngModel)]="content"></textarea>
        <label>{{ 'features.user.collaboration.create.gallery_description' | translate }}</label>
      </div>

      <div class="mt-3">
        <div class="flex align-items-center gap-2 mb-3">
          <p-checkbox
            [binary]="true"
            [(ngModel)]="copyMediaContentToHistoryContent"
            inputId="copyMediaContentToHistoryContent"
            (onChange)="copyToHistoryContent()"
          ></p-checkbox>
          <label for="copyMediaContentToHistoryContent">
            {{ 'features.user.collaboration.create.copy_from_description' | translate }}
          </label>
        </div>

        <div class="flex align-items-center gap-2 mb-3">
          <p-checkbox
            [binary]="true"
            [(ngModel)]="createHistoryEntryOnApproval"
            [disabled]="isHistoryCheckboxLocked()"
            inputId="postHistoryOnApproval"
          ></p-checkbox>
          <label for="postHistoryOnApproval">
            {{ 'features.user.collaboration.create.history_on_approval' | translate }}
          </label>
        </div>

        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="p-fluid p-float-label mb-3 md:mb-0">
              <p-calendar
                appendTo="body"
                inputId="postHistoryEntryStartDate"
                [showIcon]="true"
                [showTime]="true"
                dateFormat="yy-mm-dd"
                [(ngModel)]="startDate">
              </p-calendar>
              <label for="postHistoryEntryStartDate">{{ 'shared.modal.modal_service.add_event.hour_from' | translate }}</label>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="p-fluid p-float-label">
              <p-calendar
                appendTo="body"
                inputId="postHistoryEntryEndDate"
                [showIcon]="true"
                [showTime]="true"
                dateFormat="yy-mm-dd"
                [(ngModel)]="endDate">
              </p-calendar>
              <label for="postHistoryEntryEndDate">{{ 'shared.modal.modal_service.add_event.hour_to' | translate }}</label>
            </div>
          </div>
        </div>

        <div class="p-fluid p-float-label collaboration-media-post-create__content mt-3">
          <textarea pInputTextarea rows="5" [autoResize]="true" [(ngModel)]="historyEntryContent"></textarea>
          <label>{{ 'feature.user.project.about.history_entry' | translate }}</label>
        </div>
      </div>
    </div>
  </div>
</div>
